import React from "react";
import {
  Alert,
  FormControlLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

export default function ImportDefaultsStep({ defaults, onDefaultsChange, mode, onModeChange, codeMapped, context = "general" }) {
  return (
    <Stack spacing={2.5}>
      <div>
        <Typography variant="h6" sx={{ fontWeight: 900 }}>Defaults y modo</Typography>
        <Typography variant="body2" color="text.secondary">
          {context === "supplier"
            ? "Estos valores completan solamente altas nuevas. Los ítems existentes conservan sus campos no mapeados."
            : "Los defaults se usan sólo cuando la fila no trae un valor mapeado para ese campo."}
        </Typography>
      </div>

      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2.5 }}>
        <Stack spacing={1.5}>
          <Typography sx={{ fontWeight: 900 }}>{context === "supplier" ? "Modo lista de proveedor" : "Modo de importación"}</Typography>
          {context === "supplier" ? (
            <Alert severity="info">
              WebProfit primero mostrará una propuesta. Los productos nuevos empiezan sin seleccionar y los existentes nunca se actualizan sin una aceptación explícita.
            </Alert>
          ) : (
            <>
              <RadioGroup value={mode} onChange={(event) => onModeChange(event.target.value)}>
                <FormControlLabel
                  value="create_only"
                  control={<Radio />}
                  label="Crear solamente — nunca actualiza un código ya existente"
                />
                <FormControlLabel
                  value="upsert_by_code"
                  control={<Radio />}
                  disabled={!codeMapped}
                  label="Crear o actualizar por código — requiere mapear Código"
                />
              </RadioGroup>
              {!codeMapped ? (
                <Alert severity="info">Mapeá Código para habilitar <strong>crear o actualizar por código</strong>.</Alert>
              ) : null}
            </>
          )}
        </Stack>
      </Paper>
      <Stack direction={{ xs: "column", md: "row" }} spacing={1.5}>
        <TextField
          fullWidth
          label="Categoría por defecto"
          value={defaults.category}
          onChange={(event) => onDefaultsChange("category", event.target.value)}
          helperText="Si queda vacío, backend usa General."
        />
        <TextField
          fullWidth
          label="Unidad por defecto"
          value={defaults.unit}
          onChange={(event) => onDefaultsChange("unit", event.target.value)}
          placeholder="un., kg, lt…"
        />
        <TextField
          select
          fullWidth
          label="Tipo de ítem por defecto"
          value={defaults.itemKind}
          onChange={(event) => onDefaultsChange("itemKind", event.target.value)}
        >
          <MenuItem value="product">Producto</MenuItem>
          <MenuItem value="service">Servicio</MenuItem>
          <MenuItem value="supply">Insumo</MenuItem>
          <MenuItem value="expense">Gasto</MenuItem>
          <MenuItem value="asset">Activo</MenuItem>
          <MenuItem value="charge">Cargo</MenuItem>
        </TextField>
      </Stack>

      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2.5 }}>
        <Typography sx={{ fontWeight: 900, mb: 1 }}>Flags por defecto</Typography>
        {context === "supplier" ? (
          <Alert severity="info" sx={{ mb: 1.25 }}>
            Las altas nuevas empiezan ocultas del catálogo público. Activá “Visible públicamente” sólo cuando la lista tenga un Precio de venta válido.
          </Alert>
        ) : null}
        <Stack direction={{ xs: "column", sm: "row" }} flexWrap="wrap" gap={1}>
          <FormControlLabel
            control={<Switch checked={defaults.active} onChange={(event) => onDefaultsChange("active", event.target.checked)} />}
            label="Activo"
          />
          <FormControlLabel
            control={<Switch checked={defaults.publicVisible} onChange={(event) => onDefaultsChange("publicVisible", event.target.checked)} />}
            label="Visible públicamente"
          />
          <FormControlLabel
            control={<Switch checked={defaults.sellable} onChange={(event) => onDefaultsChange("sellable", event.target.checked)} />}
            label="Vendible"
          />
          <FormControlLabel
            control={<Switch checked={defaults.purchasable} onChange={(event) => onDefaultsChange("purchasable", event.target.checked)} />}
            label="Comprable"
          />
        </Stack>
      </Paper>
    </Stack>
  );
}
